module.exports = __webpack_public_path__ + "static/front-42cb959239d97aa53145e057bddbcbfc.jpg";